export const HOW_WE_WORK: string[] = [
  'We take action now. Same-day replies.',
  'How we do one thing is how we do everything. Details matter.',
  'Client experience matters as much as results.',
  'We speak with confidence. No yes-men.',
]

export const SEATS: string[] = [
  'Account Manager',
  'Project Manager',
  'Production Manager',
  'Creative Strategist',
  'Ads Manager',
  'Videographer',
  'Social Media Manager',
  'Sales Manager',
  'Sales Agent',
  'Appointment Setter',
  'GHL Specialist',
]

export interface HiringStep {
  label: string
  title: string
  duration: string
}

export const HIRING_STEPS: HiringStep[] = [
  {
    label: 'Step 1',
    title: 'This form',
    duration: '10 min',
  },
  {
    label: 'Step 2',
    title: 'Short video prompts',
    duration: '10 min',
  },
  {
    label: 'Step 3',
    title: 'Small work sample, made-up company',
    duration: '60 min',
  },
  {
    label: 'Step 4',
    title: 'Decision',
    duration: '',
  },
]

export const TIMEZONES: { value: string; label: string }[] = [
  { value: 'et', label: 'Eastern (ET)' },
  { value: 'ct', label: 'Central (CT)' },
  { value: 'mt', label: 'Mountain (MT)' },
  { value: 'pt', label: 'Pacific (PT)' },
  { value: 'latam', label: 'Latin America' },
  { value: 'europe', label: 'Europe' },
  { value: 'asia', label: 'Asia / Pacific' },
  { value: 'other', label: 'Other' },
]

export const WORK_SETUPS: { value: string; label: string }[] = [
  { value: 'in_person', label: 'In person (our office in Doral, FL)' },
  { value: 'remote', label: 'Remote' },
  {
    value: 'hybrid',
    label:
      'Hybrid (some days in our Doral, FL office — you\u2019d need to live nearby)',
  },
]

/** Seats where we specifically want to see their content work. */
export const CONTENT_SEATS: string[] = [
  'Production Manager',
  'Creative Strategist',
  'Videographer',
  'Social Media Manager',
]

export const START_DATES: { value: string; label: string }[] = [
  { value: 'immediately', label: 'Immediately' },
  { value: '2_weeks', label: 'Within 2 weeks' },
  { value: '30_days', label: 'Within 30 days' },
  { value: 'later', label: 'More than 30 days out' },
]

export const EXPERIENCE_LEVELS: { value: string; label: string }[] = [
  { value: '0_1', label: 'Less than 1 year' },
  { value: '1_3', label: '1 to 3 years' },
  { value: '3_5', label: '3 to 5 years' },
  { value: '5_plus', label: '5+ years' },
]

export const REFERRAL_SOURCES: { value: string; label: string }[] = [
  { value: 'social', label: 'Social Media' },
  { value: 'referral', label: 'Referral / Word of Mouth' },
  { value: 'website', label: 'Website' },
  { value: 'google', label: 'Google' },
  { value: 'other', label: 'Other' },
]

export interface WrittenQuestion {
  name: string
  label: string
  placeholder: string
}

export const WRITTEN_QUESTIONS: WrittenQuestion[] = [
  {
    name: 'answerResult',
    label:
      "What's a result you drove that you can prove? Give us the numbers, before and after.",
    placeholder:
      'Be specific. What did you inherit, what did you change, what did it become?',
  },
  {
    name: 'answerDetail',
    label: 'Tell us about a detail everyone else missed that you caught.',
    placeholder: 'What was it, how did you catch it, and what did it save?',
  },
  {
    name: 'answerPushback',
    label:
      "A client pushes back on your recommendation and you know you're right. What do you do?",
    placeholder: 'Walk us through how you actually handle it.',
  },
  {
    name: 'answerThinking',
    label:
      'Two tasks are due at the same time. You only have time for one. Walk us through how you pick \u2014 and what you do about the other one.',
    placeholder: 'How you decide, and how you handle what gets left.',
  },
]
